// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Lm6pa","rootMobile":"styles_rootMobile__2Un8G"};